import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { history } from '../store'

import { updateOperator, fetchOperators } from '../actions/operators'

class OperatorsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      saleblockConfirmShown: false,
      operatorId: null,
      operatorBlocked: null,
    };

    this.updateSaleblock = this.updateSaleblock.bind(this)

    this.saleblockConfirmShow = this.saleblockConfirmShow.bind(this)
    this.saleblockConfirmToggle = this.saleblockConfirmToggle.bind(this)
  }

  goTo(id, e) {
    e.stopPropagation();
    history.push(`/operators/${id}`)
  }

  goToCalendar(id, e) {
    e.stopPropagation();
    history.push(`/calendars/${id}`)
  }

  goToRule(id, e) {
    e.stopPropagation();
    history.push(`/rules`)
  }

  getInvoiceName(type) {
    switch (type) {
      case 'Invoice': return 'Factura'
      case 'Note': return 'Albarán'
      case 'Free': return 'No Contable'
    }
  }

  handleSaleblockClick = (operator, e) => {
    e.stopPropagation();
    this.saleblockConfirmShow(operator._id, operator.Blocked);
  }

  updateSaleblock() {
    const { updateOperator, fetchOperators } = this.props

    let body = {};
    body.Blocked = !this.state.operatorBlocked

    updateOperator(this.state.operatorId, body)
      .then(() => {
        fetchOperators();
      })
      .catch((error) => {
        console.error(error);
      });

    this.saleblockConfirmToggle()
  }

  saleblockConfirmShow(id, blocked) {
    this.setState({
      saleblockConfirmShown: true,
      operatorId: id,
      operatorBlocked: blocked
    })
  }

  saleblockConfirmToggle() {
    this.setState({ saleblockConfirmShown: !this.state.saleblockConfirmShown })
  }

  getBusinessRules(rules) {
    if (!rules || rules.length === 0) {
      return null;
    }

    return rules.filter(rule => rule.BusinessRule != null).map((rule, index) => (
      <button
        key={rule._id}
        className={`op-chip ${rule.BusinessRule.Active ? 'op-chip-active' : 'op-chip-inactive'}`}
        onClick={e => this.goToRule(rule.BusinessRule._id, e)}
      >
        <i className={`fas mr-1 ${rule.BusinessRule.Active ? 'fa-check' : 'fa-ban'}`}></i>
        {rule.BusinessRule.Name}
      </button>
    ));
  }

  render() {

    return (
      <>
        <div className="operators-list">
          {this.props.operators.map(operator => (
            <div key={operator._id} className="op-rowcard" onClick={e => this.goTo(operator._id, e)}>
              <div className="op-rowcard-main">
                <div className="op-rowcard-name">
                  <i className="fas fa-handshake"></i>
                  {operator.Name}
                </div>
                <span className={`op-badge ${operator.Blocked ? 'danger' : 'success'}`}>
                  <i className={`fas mr-1 ${operator.Blocked ? 'fa-ban' : 'fa-check'}`}></i>
                  {operator.Blocked ? 'Venta deshabilitada' : 'Venta habilitada'}
                </span>
              </div>
              <div className="op-rowcard-params">
                <div className="op-param">
                  <span className="op-label">Modelo de facturación</span>
                  <span className="op-value">{this.getInvoiceName(operator.InvoiceType)}</span>
                </div>
                <div className="op-param">
                  <span className="op-label">Canal Propio Baqueira</span>
                  <span className="op-value">{operator.External ? 'SI' : 'NO'}</span>
                </div>
                <div className="op-param">
                  <span className="op-label">NIF</span>
                  <span className="op-value">{operator.Nif}</span>
                </div>
                <div className="op-param">
                  <span className="op-label">Calendario de precios</span>
                  <button
                    className="op-chip op-chip-calendar"
                    onClick={e => operator.Calendar && this.goToCalendar(operator.Calendar._id, e)}
                  >
                    <i className="fas fa-calendar-alt mr-1"></i>
                    {operator.Calendar ? operator.Calendar.Name : 'None'}
                  </button>
                </div>
                <div className="op-param op-param-rules">
                  <span className="op-label">Reglas de negocio</span>
                  <div className="op-rules-chips">
                    {this.getBusinessRules(operator.BusinessRules) || <span className="op-value op-muted">—</span>}
                  </div>
                </div>
              </div>
              <div className="op-rowcard-actions">
                <button
                  className={`op-btn ${operator.Blocked ? 'op-btn-success' : 'op-btn-danger'}`}
                  onClick={(e) => this.handleSaleblockClick(operator, e)}
                >
                  <i className={`fas mr-1 ${operator.Blocked ? 'fa-check' : 'fa-ban'}`}></i>
                  {operator.Blocked ? 'Habilitar' : 'Deshabilitar'}
                </button>
                <button className="op-btn op-btn-view" onClick={e => this.goTo(operator._id, e)}>
                  <i className="fas fa-eye mr-1"></i>
                  Ver detalles
                </button>
              </div>
            </div>
          )
          )}
        </div>
        <div>
          <Modal isOpen={this.state.saleblockConfirmShown}
            toggle={this.saleblockConfirmToggle} className="op-modal">
            <ModalHeader toggle={this.saleblockConfirmToggle}>
              {this.state.operatorBlocked != null && this.state.operatorBlocked ?
                (<p className="text-center">Habilitar venta</p>) : (<p className="text-center">Deshabilitar venta</p>)
              }
            </ModalHeader>
            <ModalBody>
              {this.state.operatorBlocked != null && this.state.operatorBlocked ?
                (
                  <div className="text-center">
                    <p>¿Estás seguro de habilitar la venta del agregador?</p>
                    <br></br>
                    <p>-Este agregador podrá vender en su plataforma.</p>
                  </div>
                ) : (
                  <div className="text-center">
                    <p>¿Estás seguro de deshabilitar la venta del agregador?</p>
                    <br></br>
                    <p>-Este agregador no podrá vender en su plataforma.</p>
                  </div>
                )
              }
            </ModalBody>
            <ModalFooter className="d-flex justify-content-center">
              <Button color="info mr-5" onClick={this.updateSaleblock}>
                Confirmar
              </Button>
              <Button color="danger" onClick={this.saleblockConfirmToggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </>
    )
  }
}

const mapStateToProps = state => ({
  operators: state.operators.operators,
})

const mapDispatchToProps = dispatch => ({
  updateOperator: bindActionCreators(updateOperator, dispatch),
  fetchOperators: bindActionCreators(fetchOperators, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(OperatorsList)
